import { CSmsCode, CSmsCodeLogin, UserContent } from "../typing";
import axios from "./axios";
import factorySingleClass from "./SingleClass";
const prefix0 =
    process.env.NODE_ENV == "development" ? "https://www.nbd.com.cn" : "https://www.nbd.com.cn";
const prefix1 =
    process.env.NODE_ENV == "development" ? "https://www.nbd.com.cn" : "https://www.nbd.com.cn";
class IndexService {
    sms(obj: CSmsCode) {
        return axios.post(`${prefix0}/nbd_api/sms/send_sm`, obj);
    }
    login(obj: CSmsCodeLogin) {
        return axios.post(`${prefix0}/nbd_api/sms/login`, obj);
    }
    submit(obj: UserContent, type_info: string) {
        return axios.post(`${prefix1}/zhuanti/activity_enters.json`, {
            detail: obj,
            zhuanti_activity_enter: {
                activity_name: "2025政府建言",
                type_info: type_info,
                uuid: `${obj.phone}-${type_info}-${Date.now()}`,
            },
        });
    }
    choosen_list(type_info: string, page = 1, per = 5) {
        return axios.get(
            `${prefix1}/zhuanti/gov_suggestion2022/choosen_list?page=${page}&per=${per}&type_info=${type_info}&for_year=2025`,
        );
    }
}

export default factorySingleClass(IndexService);
